import React, { useContext } from 'react'
import { RiskProductsContext } from '../context'
import { Index } from './Index/index'
import { Create } from './Create/index'
import { Form } from './Form/index'
import { Destroy } from './Destroy/index'

export const Views = () => {
  const { state } = useContext(RiskProductsContext)
  const { screen } = state
  return (
    {
      index: () => <Index />,
      create: () => <Create />,
      form: () => <Form />,
      destroy: () => <Destroy />

    }[screen || 'index']()
  )
}
